<template>
  <div class="select-adicionar-campos">
    <div class="container-search">
      <i class="fa fa-search icn-search"></i>
      <input
        type="text"
        class="ipt-search"
        placeholder="Busque pelo campo"
        v-model="search"
      />
    </div>
    <div class="container-items">
      <div v-for="campo in camposFiltrados" :key="campo.id" class="item" @click="handleClickElemenToChecked(campo.filtro)">
        <tool-tip 
          tag="input"
          @click.stop="handleClickElemenToChecked(campo.filtro)"
          :texto="campo.default ? 'Este é um campo padrão do filtro, então não pode ser desabilitado.' : ''"
          placement="bottom"
          data-custom-class="custom-maino-tooltip"
          type="checkbox"
          :name="campo.filtro"
          :id="`${campo.filtro}_filtro`"
          :value="campo.filtro"
          class="custom-checkbox"
          :checked="itemsTemporariosIds.has(campo.filtro)"
          :disabled="campo.default"
        />
        <span>{{ campo.name }}</span>
      </div>
    </div>
    <div class="container-button-aplicar">
      <button @click="salvar" class="btn btn-maino">Salvar</button>
    </div>
  </div>
</template>
<script>
import ToolTip from '../../../../helpers/ToolTip.vue';
export default {
  components: {
    ToolTip,
  },
  props: {
    filtrosSelecionados: {
      type: Array,
      required: true
    },
    filtros: {
      type: Array,
      required: true
    },
    campos: {
      type: Array,
      required: true
    }
  },
  emits: ['adicionarFiltro', 'close'],
  data() {
    return {
      itemsChecked: [],
      itemsTemporarios: [],
      search: ''
    }
  },
  computed: {
    camposFiltrados() {
      return this.campos.filter(campo => {
         const name = this.$removeAccents(campo.name.toLowerCase())
         const search = this.$removeAccents(this.search.toLowerCase())
         return name.includes(search)
     });
    },
    itemsTemporariosIds() {
      return new Set(this.itemsTemporarios.map(item => item.filtro));
    }
  },
  watch: {
    filtros: {
      immediate: true,
      handler() {
        this.inicializarItemsTemporarios();
      }
    }
  },
  methods: {
    salvar() {
      this.itemsChecked = [...this.itemsTemporarios];
      this.$emit('adicionarFiltro', this.itemsChecked);
      this.$emit('close');
    },
    handleClickElemenToChecked(filtro) {
      const campo = this.campos.find(c => c.filtro === filtro);
      if (!campo || campo.default) return;
      
      const itemIndex = this.itemsTemporarios.findIndex(item => item.filtro === filtro);
      
      if (itemIndex >= 0) {
        this.itemsTemporarios.splice(itemIndex, 1);
      } else {
        this.itemsTemporarios.push(campo);
      }
    },
    inicializarItemsTemporarios() {
      this.itemsTemporarios = this.filtros.map(filtro => {
        const campo = this.campos.find(c => c.filtro === filtro.filtro);
        return campo || filtro;
      }).filter(Boolean);
      
      this.campos.forEach(campo => {
        if (campo.default) {
          const jaExiste = this.itemsTemporarios.some(item => item.filtro === campo.filtro);
          if (!jaExiste) {
            this.itemsTemporarios.push(campo);
          }
        }
      });
    }
  },
  mounted() {
    this.inicializarItemsTemporarios();
    
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.select-adicionar-campos') && !event.target.closest('.container-btn-adicionar-filtro')) {
        this.$emit('close');
      }
    });
  }
}
</script>
